import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const SK: DeepPartial<Payments> = {
    checkDomesticMatchString:
        /^[ !"#$%&'()*+,\-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ĄŁ¤ĽŚ§ŠŞŤŹŽŻ°ą˛łľś¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙]+$/.toString(),
    useTransferDateWhenSigningDoneFlag: false,
    maxDaysInFuture: 60,
    feeFlags: false,
    daysOfRepetition: 14,
    showFeeSharing: true,
    showTransactionType: true,
    redoReplyEngine: 'paymentService',
};
